import { Menu } from '@mui/material';
import { RiCloseLine } from '@remixicon/react';
import { AgButton, AgText } from 'src/components/ui';
import AttachedLabel from './AttachedLabel';
import { useLabelAttachmentsStore } from './labelAttachments.store';

export default function ShowMoreLabelsDropdown({ anchorEl, hiddenLabels, canEdit }) {
  const open = useLabelAttachmentsStore((state) => state.showMoreLabelsOpen);
  const close = useLabelAttachmentsStore((state) => state.closeShowMoreLabelsDropdown);

  return (
    <Menu anchorEl={anchorEl.current} open={open} onClose={close} sx={{ zIndex: 210001 }}>
      <div className="flex flex-col px-3 py-1" style={{ minWidth: '195px' }}>
        <div className="flex gap-2 w-full justify-between">
          <AgText size="12" className="uppercase tracking-wider" color="secondary">
            More Labels
          </AgText>
          <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={close}>
            <RiCloseLine size={16} />
          </AgButton>
        </div>
      </div>
      <div className="flex flex-col gap-1 px-1">
        {hiddenLabels.map((label) => (
          <div className="flex" key={label.labelDefinition.label}>
            <AttachedLabel {...label} canEdit={canEdit} />
          </div>
        ))}
      </div>
    </Menu>
  );
}
